//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import React, { CSSProperties } from 'react';
import styled from 'styled-components';

import LabeledCheckbox from '@components/atoms/labeled-checkbox/LabeledCheckbox';
import Text from '@components/atoms/text/Text';
import { ILabel } from '@models/ILabel';
import { Mixins } from '@theme/mixins';

interface IOwnProps {
  label: ILabel;
  isInlineCount?: boolean;
  isChecked: boolean;
  handleCheckboxClick: (isChecked: boolean) => void;
  className?: string;
  style?: CSSProperties;
}

type Props = IOwnProps;

const LabelsSelectCheckboxRow: React.FunctionComponent<Props> = ({
  label,
  isInlineCount = false,
  isChecked,
  handleCheckboxClick,
  className,
  style,
}) => {
  const { label: title, count } = label;

  const handleClick = () => handleCheckboxClick(!isChecked);

  const displayCount = isInlineCount ? ` (${count})` : count;

  return (
    <CheckboxRow
      style={style}
      className={className}
      isInlineCount={isInlineCount}
    >
      <LabeledCheckbox
        label={title}
        isChecked={isChecked}
        handleClick={handleClick}
      />
      <StyledText mixin={Mixins.Text.Body} onClick={handleClick}>
        {displayCount}
      </StyledText>
    </CheckboxRow>
  );
};

export default LabelsSelectCheckboxRow;

const StyledText = styled(Text)(
  ({ theme }) => `
  padding: ${theme.spacings[1]};
`,
);

const CheckboxRow = styled.div<{ isInlineCount: boolean }>(
  ({ isInlineCount }) => `
  display: flex;
  align-items: center;
  justify-content: ${isInlineCount ? 'unset' : 'space-between'};
`,
);
